/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import { createPromiseRequest } from './util/createPromiseRequest';
import { hasAccessToken } from '../../../utils/token';
import { injectAegionFilters, injectClientFilters } from './util/reportaggsfilters';
import { sortPmFilterStoreNaLast, sortCtFilterStoreNaLast, unshrinkUserFilterItems } from './util/userFilterItems';

const EMPTY_RES = {
	customers: [],
	entities: {},
	areas: {},
	pipes: {},
	regulatoryStatuses: {},
	jobs: {},
	lines: {},
	surveyTypes: {},
	pms: {},
	cts: {},
	reportTypes: {},
	reportStatuses: {},				
}

export const fetchReportsAggsFilters = async (customerName) => {
	const url = '/report-filters';

	if (hasAccessToken()) {
		const createFetch = ({ include, exclude }) => createPromiseRequest({
      url,
      method: 'POST',
      data: {
        customer: customerName,
				include,
				exclude,
      }      
		});

		const fetchMost = createFetch({ exclude: ['PMS', 'CTS']});
		const fetchPMS = createFetch({ include: ['PMS']});
		const fetchCTS = createFetch({ include: ['CTS']});
		const [resMost, resPMS, resCTS] = await Promise.all([
			(async () => {
				try {
					const res = await fetchMost();
					return res;
				} catch (e) {
					console.error(e);
					return _.cloneDeep(EMPTY_RES);
				}
			})(),
			(async () => {
				try {
					const res = await fetchPMS();
					res.pms = sortPmFilterStoreNaLast(unshrinkUserFilterItems(res.pms));
					return res;
				} catch (e) {
					console.error(e);
					return _.cloneDeep(EMPTY_RES);
				}
			})(),
			(async () => {
				try {
					const res = await fetchCTS();
					res.cts = sortCtFilterStoreNaLast(unshrinkUserFilterItems(res.cts));
					return res;
				} catch (e) {
					console.error(e);
					return _.cloneDeep(EMPTY_RES);
				}
			})(),
		]);

		const res = {
			...resMost,
			pms: resPMS.pms,
			cts: resCTS.cts,
		}

		return injectClientFilters(injectAegionFilters(res));
	}
	return Promise.reject(new Error('Missing Token'));
};

